import * as React from "react";
import ContactoContainer from "../containers/contacto-container";

export default function ContactoPage() {
  return <ContactoContainer></ContactoContainer>;
}
